<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>Seriové čísla jednotek</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="3">
        <template v-if="'serialNo' in this.data">
          <v-text-field disabled readonly :label="$t('settings.serialNumber') + ': HMI'" v-model="this.data.serialNo"></v-text-field>
        </template>

        <template v-if="'serialNumber' in this.data">
          <v-text-field disabled readonly :label="$t('settings.serialNumber') + ': HMI'" v-model="this.data.serialNumber"></v-text-field>
        </template>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field disabled readonly :label="$t('settings.serialNumber') + ': INVERTER'" v-model="this.data.inverter.serialNumber"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" v-for="(item, index) in this.data.mppt" :key="index + 'A'">
        <v-text-field disabled readonly :label="$t('settings.serialNumber') + ': MPPT' + (parseInt(index) + 1)" v-model="item.serialNumber"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" v-for="(item, index) in this.data.battery.batteries" :key="index + 'B'">
        <v-text-field disabled readonly :label="$t('settings.serialNumber') + ': DAB' + (parseInt(index) + 1)" v-model="item.serialNumber"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "StationSerialNumbers",
  props: {
    data: {
      type: Object,
      default: null,
      require: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},

  computed: {},
  methods: {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
